import 'redsign.university.fancybox';

if ('Fancybox' in window)
{
	Fancybox.bind('[data-photogallery]', {
		groupAttr: 'data-photogallery',
		click: () => false,
		Image: {
			zoom: false
		},
		Toolbar: {
			display: ['slideshow', 'fullscreen', 'thumbs', 'close']
		},
	});
}